/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserReactionCategoryReference } from './UserReactionCategoryReference';
import {
    UserReactionCategoryReferenceFromJSON,
    UserReactionCategoryReferenceFromJSONTyped,
    UserReactionCategoryReferenceToJSON,
} from './UserReactionCategoryReference';
import type { UserReactionType } from './UserReactionType';
import {
    UserReactionTypeFromJSON,
    UserReactionTypeFromJSONTyped,
    UserReactionTypeToJSON,
} from './UserReactionType';

/**
 * 
 * @export
 * @interface UserReactionRequest
 */
export interface UserReactionRequest {
    /**
     * 
     * @type {UserReactionType}
     * @memberof UserReactionRequest
     */
    reactionType: UserReactionType;
    /**
     * 
     * @type {string}
     * @memberof UserReactionRequest
     */
    message: string;
    /**
     * 
     * @type {UserReactionCategoryReference}
     * @memberof UserReactionRequest
     */
    category: UserReactionCategoryReference;
    /**
     * 
     * @type {string}
     * @memberof UserReactionRequest
     */
    contactPhoneNumber?: string | null;
}

/**
 * Check if a given object implements the UserReactionRequest interface.
 */
export function instanceOfUserReactionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reactionType" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "category" in value;

    return isInstance;
}

export function UserReactionRequestFromJSON(json: any): UserReactionRequest {
    return UserReactionRequestFromJSONTyped(json, false);
}

export function UserReactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReactionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reactionType': UserReactionTypeFromJSON(json['reactionType']),
        'message': json['message'],
        'category': UserReactionCategoryReferenceFromJSON(json['category']),
        'contactPhoneNumber': !exists(json, 'contactPhoneNumber') ? undefined : json['contactPhoneNumber'],
    };
}

export function UserReactionRequestToJSON(value?: UserReactionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reactionType': UserReactionTypeToJSON(value.reactionType),
        'message': value.message,
        'category': UserReactionCategoryReferenceToJSON(value.category),
        'contactPhoneNumber': value.contactPhoneNumber,
    };
}

